import { request } from './request.js'

export const getFavorites = () => request.get('user/favorites')
export const createFavorites = id => request.post('user/favorites', { product_id: id })
export const deleteFavorites = id => request.delete(`user/favorites/${id}`)
